module.exports = __webpack_public_path__ + "static/media/impacts.d539afe3.svg";